import { types } from "../../types/types";

const initialState = {
  prestadores: null,
  rubros: [],
  zonas: [],
  centrosMedicos: [],
  rankingsCartilla: [],
  cartilla: [],
  planes: [],
  planesCuentas: [],
  categorias: [],
  loading: false,
};

export const contratacionesCartillaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesTraerCartillaPrestadoresSuccess:
      return {
        ...state,
        prestadores: action.payload,
      };
    case types.contratacionesTraerCartillaPrestadoresError:
      return {
        ...state,
        prestadores: [],
      };
    case types.contratacionesGetRubrosSuccess:
      return {
        ...state,
        rubros: action.payload,
      };
    case types.contratacionesGetRubrosError:
      return {
        ...state,
        rubros: [],
      };
    case types.contratacionesGetZonasSuccess:
      return {
        ...state,
        zonas: action.payload,
      };
    case types.contratacionesGetZonasError:
      return {
        ...state,
        zonas: [],
      };
    case types.contratacionesGetCentrosMedicosSuccess:
      return {
        ...state,
        centrosMedicos: action.payload,
      };
    case types.contratacionesGetCentrosMedicosError:
      return {
        ...state,
        centrosMedicos: [],
      };
    case types.contratacionesGetRankingsCartillaSuccess:
      return {
        ...state,
        rankingsCartilla: action.payload,
      };
    case types.contratacionesGetRankingsCartillaError:
      return {
        ...state,
        rankingsCartilla: [],
      };
    case types.contratacionesGetCartillaSuccess:
      return {
        ...state,
        cartilla: action.payload,
      };
    case types.contratacionesGetCartillaError:
      return {
        ...state,
        cartilla: [],
      };
    case types.contratacionesGetPlanesSuccess:
      return {
        ...state,
        planes: action.payload,
      };
    case types.contratacionesGetPlanesError:
      return {
        ...state,
        planes: [],
      };
    case types.contratacionesGetPlanesCuentasSuccess:
      return {
        ...state,
        planesCuentas: action.payload,
      };
    case types.contratacionesGetPlanesCuentasError:
      return {
        ...state,
        planesCuentas: [],
      };
    case types.contratacionesGetCategoriasSuccess:
      return {
        ...state,
        categorias: action.payload,
      };
    case types.contratacionesGetCategoriasError:
      return {
        ...state,
        categorias: [],
      };
    case types.contratacionesContratoLimpiarSeleccion: {
      return {
        ...state,
        prestadores: null,
      };
    }
    default:
      return state;
  }
};
